var map = {
	"./customerFeel-excited.jpg": 189,
	"./customerFeel-happy.jpg": 190,
	"./customerFeel-relieved.jpg": 191,
	"./customerFeel-smart.jpg": 192,
	"./endgif.gif": 140,
	"./favoriteTreat-discount.jpg": 193,
	"./favoriteTreat-fun.jpg": 194,
	"./favoriteTreat-hug.jpg": 195,
	"./favoriteTreat-money.jpg": 196,
	"./lunchType-pasta.jpg": 197,
	"./lunchType-pizza.jpg": 198,
	"./lunchType-salad.jpg": 199,
	"./lunchType-sandwich.jpg": 200,
	"./movieType-action.jpg": 201,
	"./movieType-animated.jpg": 202,
	"./movieType-comedy.jpg": 203,
	"./movieType-documentary.jpg": 204,
	"./movieType-foreign.jpg": 205,
	"./movieType-romcom.jpg": 206,
	"./movieType-scifi.jpg": 207,
	"./movieType-thriller.jpg": 208,
	"./petType-bees.jpg": 209,
	"./petType-cat.jpg": 210,
	"./petType-dog.jpg": 211,
	"./petType-fish.jpg": 212,
	"./petType-goat.jpg": 213,
	"./petType-lizard.jpg": 214,
	"./result-consumer.jpg": 215
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 420;